import Sortable from 'sortablejs'
import { default as StimulusSortable } from '@stimulus-components/sortable'

// Override the Sortable controller to work when moving nested sortables.
// By default, child nodes are removed and re-added to the DOM when moved,
// which calls disconnect() and destroys the Sortable instance.
// Instead, only destroy the Sortable instance if it doesn't have a parent sortable.
export default class extends StimulusSortable {
  connect() {
    let existingSortable = Sortable.get(this.element)
    if (existingSortable) {
      this.sortable = existingSortable
    } else {
      super.connect()
    }
  }

  disconnect() {
    let parentSortable = this.element.parentNode.closest("[data-controller~=sortable]")
    if (!parentSortable) {
      super.disconnect()
    }
  }
}
